<template>
  <netaccuse-header />
  <router-view />
  <netaccuse-footer />
  <Protocol v-model:show="showDialog" @readSuccess="showDialog = false" />
</template>

<script>
// import { defineComponent } from 'vue';
import NetaccuseHeader from './components/header';
import NetaccuseFooter from './components/footer';
import Protocol from './components/protocol';
// 兼容桌面端事件，比如pick滑动
import './helper/vant-touch-emulator';

import { ref } from 'vue';

export default {
  name: 'Main',
  components: {
    NetaccuseHeader,
    NetaccuseFooter,
    Protocol
  },
  setup() {
    // 处理页面title
    const $title = document.getElementsByTagName('title');
    $title[0].text = '网安警务室';

    let showDialog = ref(true);
    return {
      showDialog
    };
  }
};
</script>
